"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSameOrBeforeDay = exports.isSameOrAfterDay = exports.isSameDay = void 0;
// eslint-disable-next-line functional/prefer-immutable-types
const isSameDay = (d1, d2) => d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
exports.isSameDay = isSameDay;
// eslint-disable-next-line functional/prefer-immutable-types
const isSameOrAfterDay = (date, baseline = new Date()) => date > baseline || (0, exports.isSameDay)(date, baseline);
exports.isSameOrAfterDay = isSameOrAfterDay;
// eslint-disable-next-line functional/prefer-immutable-types
const isSameOrBeforeDay = (date, baseline = new Date()) => date < baseline || (0, exports.isSameDay)(date, baseline);
exports.isSameOrBeforeDay = isSameOrBeforeDay;
